export default __webpack_public_path__ + "static/media/upload-pdf-icon.fe2a8a10.png";